export default {

    methods: {
        changeState(url, values, status, text = null, typeModal) {
            return new Promise((resolve, reject) => {
                typeModal(this.$t(text)).then((response) => {
                    if (response) {
                        if (!values) {
                            values = {};
                        }
                        values["status"] = status;
                        values["note"] = response;
                        this.$http
                            .post(
                                url,//this.urlSave + "/" + this.item.id,
                                values,
                                true,
                                true
                            )
                            .then((response) => {
                                if (response.success) {
                                    /**/
                                    resolve(response)
                                } else {
                                    reject(response)
                                }
                            });
                    } else {
                        resolve(false)
                    }
                });
            })
        }
    }
}